export default __webpack_public_path__ + "static/media/apple-store.6c1869e5.png";